/* eslint-disable no-multi-str */
import React from "react"
import SectionContainer from "../components/SectionContainer"
import SkillViewBuilder from "./SkillViewBuilder"

import sapLogo from "../images/saplogo.png"
import unityLogo from "../images/unitylogo.png"

const skills = [
  {
    name: "Unity Engine",
    icon: unityLogo,
    proficiency: "Proficient",
    description: "Popular engine for building 2D and 3D games",
    customtext: "I used Unity to build the Virtual Reality comedy \
                game 'Cooking with Cannibals' as part of the independent \
                game studio 'Tastes Like Chicken Games'.",
  },
  {
    name: "SAPUI5",
    icon: sapLogo,
    proficiency: "Proficient",
    description: "Proprietary framework for building web interfaces",
    customtext: "I've built multiple corporate applications using SAPUI5 for the frontend.",
  },
  {
    name: "HANAXS",
    icon: sapLogo,
    proficiency: "Familiar",
    description: "Proprietary application server leveraging SAP technologies",
    customtext: "I've used HANAXS to serve corporate web applications. The HANA \
                layer hosts the business logic and connects to the database \
                system for data persistence.",
  },
  {
    name: "NetWeaver",
    icon: sapLogo,
    proficiency: "Familiar",
    description: "Proprietary application server and development platform",
    customtext: "I've used Netweaver early in my SAP career to provide web \
                services for an application and connect to the database. I \
                also used it during maintenance to check crash logs and find \
                performance bottlenecks.",
  },
]



const OtherSkills = () => (
  <SectionContainer header="Other">
    <SkillViewBuilder skills={skills} />
  </SectionContainer>
)

export default OtherSkills
